import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import PwaSplash from "@/components/PwaSplash";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PwaSplash />
    <App />
  </React.StrictMode>,
);
